export const categories = [
  {
    slug: "daily-contest",
    name: "每日大赛",
    description: "51吃瓜每日大赛最新热点，实时更新全网热议八卦赛事，不错过任何一个精彩瞬间",
    icon: "ri-live-line",
    color: "from-rose-500 to-orange-500",
  },
  {
    slug: "taipei-nana",
    name: "台北娜娜",
    description: "台北娜娜最新合集，热门视频资源一网打尽，娜娜粉丝必看专区",
    icon: "ri-star-line",
    color: "from-pink-500 to-rose-500",
  },
  {
    slug: "mori-show",
    name: "莫里秀",
    description: "51吃瓜莫里秀视频专题，莫里秀最新内容与独家资源持续更新",
    icon: "ri-fire-line",
    color: "from-amber-500 to-red-500",
  },
  {
    slug: "doll-sister",
    name: "玩偶姐姐",
    description: "玩偶姐姐资源合集，高清视频与独家内容，深度吃瓜不容错过",
    icon: "ri-heart-line",
    color: "from-purple-500 to-pink-500",
  },
  {
    slug: "exposure",
    name: "黑料吃瓜",
    description: "黑料吃瓜专区，娱乐圈内幕与独家爆料，满足你的八卦好奇心",
    icon: "ri-spy-line",
    color: "from-gray-600 to-gray-900",
  },
  {
    slug: "collection",
    name: "视频合集",
    description: "精选视频合集，高清资源汇总，一站式吃瓜体验",
    icon: "ri-play-list-line",
    color: "from-cyan-500 to-blue-500",
  },
];